import Headroom from "react-headroom"
import Button from "@/components/Button"
import Logo from "@/components/Logo"
import UserNavItem from "@/components/UserNavItem"
import * as styles from "@/styles/modules/Header.module.scss"
import type { UserState } from "@/redux/features/activeUserSlice"

interface AmbassadorHeaderProps {
  activeUser: UserState
  forceBackground: boolean
  forceTheme?: "light" | "dark"
}

const AmbassadorHeader = ({
  activeUser,
  forceBackground = false,
  forceTheme,
}: AmbassadorHeaderProps) => {
  return (
    <>
      <Headroom
        className={[
          styles.wrapper,
          forceBackground ? styles.forceBackground : "",
          forceTheme ? styles[`force${forceTheme}`] : "",
        ].join(" ")}
        disableInlineStyles
        upTolerance={5}
        downTolerance={10}
      >
        <header className={styles.container}>
          <Logo
            flavor={
              forceTheme
                ? forceTheme === "light"
                  ? "chocolate"
                  : "vanilla"
                : null
            }
            className={styles.logo}
            linkTo="/"
          />

          {activeUser.ambassadorPermission ? (
            <UserNavItem
              forceTheme={forceTheme}
              identifier={activeUser.email || activeUser.phone}
            />
          ) : (
            <div className={styles.ctaWrapper}>
              <div className={styles.btnGroup}>
                <Button uiType="secondary" size="small" to="/ambassadors/login">
                  Already an Ambassador?
                </Button>
              </div>
            </div>
          )}
        </header>
      </Headroom>
    </>
  )
}

export default AmbassadorHeader
